import React from "react";
import { useNavigate } from "react-router-dom";
import "../css/ProductGrid.css";

const ProductGrid = ({ products, isSearchPage }) => {
    const navigate = useNavigate();

    const handleProductClick = (product) => {
    const isParentWithOptions = Array.isArray(product.options);

    const productDetails = {
        id: product.id,
        name: product.name,
        image: isSearchPage ? product.img : product.image,
        price: product.price,
    };

    localStorage.setItem("product", JSON.stringify(productDetails));

    if (product.name === "Fittings / Accessories / Replacement Parts") {
        navigate("/products/fittings");
        return;
    }

    if (product.name === "EMS") {
        navigate("/products/ems");
        return;
    }

    if (isParentWithOptions) {
        // Navigate to parent product (options page), no image passed
        navigate(`/products/${product.id}`);
        return;
    }

    // Navigate to specific product detail
    navigate(`/products/${product.id}`, {
        state: { image: productDetails.image },
    });
};


    return (
        <div className="layout-container">
            {/* Services Sidebar Fixed */}
            {!isSearchPage && (
                <div className="services-sidebar-fixed">
                    <h2 className="services-header">Our Services</h2>
                    <div className="green-ba"></div>

                    <div className="services-links">
                        <a href="/service1" className="service-link">Blender Repair</a>
                        <a href="/service2" className="service-link">Flowmeter Repair</a>
                        <a href="/service3" className="service-link">Product Maintenance</a>
                        <a href="/faq" className="service-link">Returns</a>
                        <a href="/contact" className="service-link">Service not found? Contact Us</a>
                    </div>
                </div>
            )}

            {/* Main Content (Right of Sidebar) */}
            <div className="main-content-with-sidebar">
                <div className="section-header">
                    <h2 className="product-greenBar">All Categories</h2>
                    <div className="green-ba"></div>
                </div>
                <div className="product-grid">
                    {products.map((product) => (
                        <div
                            className="product-card"
                            key={product.id}
                            onClick={() => handleProductClick(product)}
                            style={{ cursor: "pointer" }}
                        >
                            <div class="productgrid-image-container">
                                <img
                                    src={isSearchPage ? product.img : product.image}
                                    alt={product.name}
                                    className="product-image"
                                />
                            </div>
                            <h3 className="product-name">{product.name}</h3>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ProductGrid;
